/** @jsx jsx */

import { ReactNode } from 'react';
import { capitalize } from 'lodash';

import { Colors, Icon, Spacer } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import Link from 'app/common/components/Link';
import { GET_HELP_CTA } from 'app/developer-v3/teams/team-technical-support-operations/get-help';
import { PARTNER_CONTACT_FORM_PATH } from 'app/developer-v3/constants';

const stylesRoot = (hasBorder: boolean) => [
  css`
    border-top: none;
    margin-top: 60px;
  `,
  hasBorder &&
    css`
      border-top: 1px solid ${Colors.GrayWarm4};
      margin-top: 0;
    `,
];

const stylesInterior = css`
  padding: 12px;
`;

const stylesLink = css`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const stylesLinkGroup = css`
  display: flex;
`;

const stylesLinkWrapper = css`
  color: ${Colors.UiPrimaryStrongest};
  &:not(:last-of-type) {
    border-right: 1px solid ${Colors.GrayWarm4};
  }
  flex: 1;
  font-weight: 600;
`;

type Props = {
  children?: ReactNode;
  hasBorder?: boolean;
};

const Footer = ({ children, hasBorder = true }: Props) => {
  return (
    <footer css={stylesRoot(hasBorder)}>
      <div css={stylesInterior}>
        {children ?? (
          <div css={stylesLinkGroup}>
            <div css={stylesLinkWrapper}>
              <Link
                href="https://docs.zapier.com/platform/quickstart/how-zapier-works"
                target="_blank"
              >
                <div css={stylesLink}>
                  <Icon
                    color="UiPrimaryStrongest"
                    name="fileGuideFill"
                    size={24}
                  />
                  <Spacer width={5} />
                  All help docs
                </div>
              </Link>
            </div>
            <div css={stylesLinkWrapper}>
              <Link href={PARTNER_CONTACT_FORM_PATH} target="_blank">
                <div css={stylesLink}>
                  <Icon
                    color="UiPrimaryStrongest"
                    name="commentBlankFill"
                    size={24}
                  />
                  <Spacer width={5} />
                  {capitalize(GET_HELP_CTA)}
                </div>
              </Link>
            </div>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
